import { render, staticRenderFns } from "./EmailListTable.vue?vue&type=template&id=16581f1f"
import script from "./EmailListTable.vue?vue&type=script&lang=js"
export * from "./EmailListTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports